import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AimoEnvironmentConnector } from './aimo-environment.connector';
import { AnalyticsConfig } from './aimo-environment.objects';

@Injectable({
    providedIn: 'root',
})
export class AimoEnvironmentService {
    constructor(protected aimoEnvironmentConnector: AimoEnvironmentConnector) {}

    analyticsConfig(): Observable<AnalyticsConfig> {
        return this.aimoEnvironmentConnector.getAnalyticsConfig();
    }
}
